export enum UserConsentType {
  Cookie = 1,
  Register = 2,
  Promotion = 3
}
